import React, { useState } from "react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import BeforeAfter from "@/components/BeforeAfter";
import GoogleReviews from "@/components/GoogleReviews";
import { REALISATIONS } from "@/data/site";

function SpotlightCard({ r, i }) {
  const [pos, setPos] = useState({ x: 50, y: 50 });
  const onMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPos({ x: ((e.clientX - rect.left) / rect.width) * 100, y: ((e.clientY - rect.top) / rect.height) * 100 });
  };
  return (
    <Reveal delay={i * 0.08}>
      <div
        data-testid={`realisation-${i}`}
        onMouseMove={onMove}
        className="group relative rounded-3xl overflow-hidden border border-ink/10 bg-ink"
      >
        <div className="relative overflow-hidden">
          <img src={r.image} alt={r.title} className="h-64 w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />
          <div
            className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            style={{ background: `radial-gradient(circle at ${pos.x}% ${pos.y}%, rgba(0,156,255,0.25), transparent 55%)` }}
          />
        </div>
        <div className="p-7">
          <h3 className="text-xl font-bold text-white">{r.title}</h3>
          <dl className="mt-5 space-y-3 text-sm">
            <div>
              <dt className="text-aqua font-bold uppercase tracking-wide text-xs">Contexte</dt>
              <dd className="text-white/70 mt-1">{r.context}</dd>
            </div>
            <div>
              <dt className="text-aqua font-bold uppercase tracking-wide text-xs">Méthode</dt>
              <dd className="text-white/70 mt-1">{r.method}</dd>
            </div>
            <div>
              <dt className="text-aqua font-bold uppercase tracking-wide text-xs">Résultat</dt>
              <dd className="text-white/70 mt-1">{r.result}</dd>
            </div>
          </dl>
        </div>
      </div>
    </Reveal>
  );
}

export default function Realisations() {
  return (
    <>
      <Seo
        title="Réalisations et Avis Clients | FuiteX Recherche de Fuite"
        description="Découvrez nos interventions de recherche de fuite d'eau en Île-de-France : cas concrets, photos avant/après et avis de nos clients."
        canonical="/realisations"
      />
      <PageHero
        overline="Réalisations"
        titleLines={["Nos réalisations", "et avis clients"]}
        subtitle="Des interventions concrètes, une fuite localisée à chaque fois. La meilleure preuve de notre savoir-faire."
        breadcrumb={[{ label: "Réalisations" }]}
      />

      <section className="bg-white py-24">
        <div className="container-x">
          <Reveal>
            <p className="overline text-aqua mb-4">Études de cas</p>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-ink max-w-2xl">
              Des cas réels, résolus sans destruction
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-6 lg:grid-cols-3">
            {REALISATIONS.map((r, i) => <SpotlightCard key={i} r={r} i={i} />)}
          </div>
        </div>
      </section>

      <section className="bg-ink py-24 grain relative overflow-hidden">
        <div className="container-x relative z-10">
          <Reveal>
            <p className="overline text-aqua mb-4">Avant / Après</p>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white max-w-2xl">
              Le résultat en un coup d'œil
            </h2>
            <p className="mt-4 text-white/60 max-w-xl">Faites glisser le curseur pour comparer l'état avant et après notre intervention.</p>
          </Reveal>
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {REALISATIONS.map((r, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <BeforeAfter before={r.before} after={r.image} label={r.title} testid={`before-after-${i}`} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <GoogleReviews />

      <CTASection />
    </>
  );
}
